import { render, staticRenderFns } from "./modal-receipt-vin.vue?vue&type=template&id=6df0c6f8"
import script from "./modal-receipt-vin.vue?vue&type=script&lang=js"
export * from "./modal-receipt-vin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormReceiptVin: require('/var/www/components/form/form-receipt-vin.vue').default})
